<template>
  <div :class="bodyBlockClass">
    <div class="h-100 d-flex flex-column flex-1-1">
      <NuxtLayout>
        <NuxtPage />
      </NuxtLayout>
    </div>
    <Footer v-if="!editProfile && showFooter"/>
    <ClientOnly>
      <ProfileFooter v-if="editProfile && tapStore.currentTap"/>
    </ClientOnly>
  </div>
  <DialogManager/>
  <ClientOnly>
    <ReCaptcha/>
  </ClientOnly>

</template>
<script setup>
import {computed} from 'vue'
import { useRoute } from 'vue-router'
import {useTapStore} from "~/stores/tapStore.js";

const route = useRoute()
const tapStore = useTapStore()

const isHomeRoute = computed(() => route.path === '/')
const isLandingRoute = computed(() => route.path.toLowerCase().includes('promo'))
const bodyBlockClass = computed(() => {
  if (isHomeRoute.value) {
    return null
  }

  return {
    'body-block': true,
    auth: !isLandingRoute.value,
    landing: isLandingRoute.value
  }
})
const showFooter = computed(() => /^(\/profile|\/|\/search|\/menu|\/404)$/.test(route.path))
const editProfile = computed(() => /^\/profile\/[^\/]+\/(edit|view)(\/(ru|kz|en))?\/?$/.test(route.path))
const userStore = useUserStore();

onMounted(() => {
  userStore.fetchAvatar()
})
</script>

<style scoped lang="sass">
.body-block
  min-height: 100dvh
  position: relative
  display: flex
  flex-direction: column
  justify-content: space-between
  background: #fff
  max-width: 420px
  margin: 0 auto
  width: 100%
  box-sizing: border-box
  &.auth
    background: transparent
  &.landing
    max-width: 100%

</style>
